<template>
    <div v-if="!item.repeat" class="my-6">
        <div class="flex items-end border-b-2 border-black py-2 avoid-page-break">
            <h3 class="whitespace-pre-line flex-1 text-xl">{{ item.title}}</h3>
            <div class="w-24 text-right text-70">
                <template
                    v-if="shouldDisplayScore">
                    <!-- {{ item.score }} / {{ item.max_score }}, weight: {{ item.weight }} -->
                    {{ $n(item.percentage/100, 'scorePercentage') }}
                </template>
            </div>
        </div>
        <SubItems
            :items="item.items"
            :resource="resource"
        />
    </div>
</template>

<script>
    import SubItems from '@/components/InspectionReport/Items/SubItems';

    export default {
        name: 'Section',
        components: { SubItems },
        props: {
            item: {
                type: Object,
                required: true,
            },
            resource: {
                type: Object,
                default: null,
            },
        },

        computed: {
            shouldDisplayScore() {
                return this.resource.template.display_score && typeof this.item.percentage !== 'undefined' && this.item.percentage !== null;
            },
            userLocale() {
                return this.$store.getters['authentication/user'].locale;
            },
        },
    };
</script>
